import * as React from "react";
import { makeStyles } from "@fluentui/react-components";
import { useEffect } from "react";
import SearchCriteria from "./index/SearchCriteria";
import RecentList from "./index/RecentList";
import IndexingForm from "./index/IndexingForm";
import services from "../services/indexService";
import { taskPaneInitailValue, useTaskPane } from "../provider/TaskPaneProvider";
import useToast from "../hooks/useToast";
import { jwtDecode } from "jwt-decode";
import { SetAxiosDefauls } from "../services/authInterceptor";
import Loader from "./index/loader";
import axios from "axios";
import { appInsights } from '../../telemetry/telemetryService';

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
  },
});

const MainContent = (props) => {
SetAxiosDefauls();
  const {
    setProfileDetails,
    taskPaneState,
    setTaskPaneState,
    profileDetails,
    setSelectedGridItem,
    setPoliciesDetailsForInsured,
    selectedItemDetailFromGrid,
    setCheckList,
    getLocationSpecificInfo,
    setUsername,
    username,
    loading,
    setLoading,
    checkList,
    selectedGridItem,
    setDocumentType,
    setDocumentClass
  } = useTaskPane();
  const urlParams = new URLSearchParams(window.location.search);
  const mode = urlParams.get('dialog');
  const actionType = mode === "compose"? "sendMailAndOpenTaskPane": "openDialog";
  const { Toaster, notify, dismissAllToasts } = useToast();
  // const accessToken = sessionStorage.getItem('access-token');
  const [accessToken, setAccessToken] = React.useState(sessionStorage.getItem('access-token') || "");
  const [authToken, setAuthToken] = React.useState(sessionStorage.getItem('auth-token') || "");
  const [graphToken, setGraphToken] = React.useState(sessionStorage.getItem('graph_token') || "");
  const getData = async () => {
    try {
      const result = await services.getUserProfileInfo(username);
        setProfileDetails(result);
        sessionStorage.setItem('userId', result[0]?.userID);
        setTaskPaneState((prev) => ({ ...prev, userId: result[0]?.userID, profileUserGroupId: result[0]?.primaryUserGroupID, userGroupId: result[0]?.primaryUserGroupID, userGroup: result[0]?.userID }));
    } catch (e) {
      console.log(e);
    }
  };

    const getAuthToken = async (name) => {
        try {
          const result = await services.getAuthToken(name);
          sessionStorage.setItem("auth-token", result.access_token);
          localStorage.setItem("auth-token", result.access_token);
          setAuthToken(result.access_token);
          setUsername(name);
        } catch (e) {
          console.log(e);
        }
    };

    const getGraphToken = async (name) => {
        try {
            const result = await services.getGraphToken(name);
            sessionStorage.setItem("graph_token", result.graph_token);
            setGraphToken(result.graph_token)
        } catch (e) {
            console.log(e);
        }
    };

    useEffect(() => {
        if (accessToken) {
            try {
                const decoded = jwtDecode(accessToken);
                const preferredName = 
                    decoded.preferred_username|| decoded?.unique_name || decoded.userPrincipalName || decoded.name || null;
                if (preferredName != null) {
                    getAuthToken(preferredName)
                    getGraphToken(preferredName)
                    sessionStorage.setItem("fromAddress", preferredName)
                  }

            } catch (err) {
                console.error("Failed to decode token:", err);
            }
        }
    }, [accessToken]);

  useEffect(() => {
      if (username && !!authToken) {
      getData();
    }
  }, [username, authToken]);

  const criteriaChange = (criteria) => criteria === "Insured" || criteria === "Policy #" || criteria === "Submission #"
    ? "Type Insured/Policy"
    : criteria === "Producer #" || criteria === "Producer Name"
      ? "Type Producer"
      : "Type claim"

  const updateState = async (key, value) => {
    dismissAllToasts();
    switch (key) {
      case "comLocId":
        setPoliciesDetailsForInsured([]);
        setSelectedGridItem([]);
        setCheckList([]);
        setDocumentType([]);
        setDocumentClass([]);
        const compId = profileDetails.filter((pd) => pd.compLocID == value)[0]?.companyID;
        if(value && compId) {
          setTaskPaneState((prev) => ({ ...prev, ...taskPaneInitailValue, [key]: value, compLocId: value, compId, searchText: "", userGroupId: prev?.profileUserGroupId, userGroup: prev?.userId }));
          await getLocationSpecificInfo(value, compId);
        } else {
          setTaskPaneState((prev) => ({ 
            ...prev, 
            ...taskPaneInitailValue, 
            [key]: value, 
            compLocId: value, 
            compId, 
            searchText: "", 
            userGroupId: prev?.profileUserGroupId, 
            userGroup: prev?.userId,
            insuredForRecentPoliciesResults: [],
            criteriaItems: [],
            criteria: "",
            insuredId: "",
          }));
        }
        break;
      case "criteria":
        let searchText = taskPaneState?.searchText;
        let checklistItem = taskPaneState?.checklistItem;
        if (criteriaChange(taskPaneState.criteria) !== criteriaChange(value)) {
          setPoliciesDetailsForInsured([]);
          setSelectedGridItem([]);
          searchText = "";
          checklistItem = "";
          if(criteriaChange(value) === "Type Insured/Policy" && taskPaneState.comLocId) {
            getLocationSpecificInfo(taskPaneState.compLocId, taskPaneState.compId, value);
          }
        }
          setTaskPaneState((prev) => ({ ...prev, [key]: value, searchText, checklistItem}));
        break;
      case "insuredId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "searchText":
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
      case "userGroupId":
        setTaskPaneState((prev) => ({ ...prev, [key]: value, userGroup: prev?.userId, taskQueue: "", taskType: "" }));
        break;
      case "docDescription":
      case "taskSubject":
        if(value?.length <= 60) {
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        } else if(!!value && value?.length > 60) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 60) }));
        }
        break;
      case "docNotes":
        if(value?.length <= 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        } else if(!!value && value?.length > 255) {
          setTaskPaneState((prev) => ({ ...prev, [key]: value.substring(0, 255) }));
        }
        break;
      case "checklistItem":
        const desctext = !!value? checkList.find(x => x.policyChecklistId == value)?.description || "" : "";
        const descTextTrim = (!!desctext && desctext?.length > 60) ? desctext.substring(0, 60) : desctext || "";
        setTaskPaneState((prev) => ({ 
          ...prev, 
          [key]: value, 
          docDescription: prev?.useChecklistItem? descTextTrim : prev?.docDescription || "",
          taskSubject: (prev?.sameAsDocDesc && prev?.useChecklistItem)? descTextTrim : prev?.taskSubject || ""
        }));
        break;
      case "useFileName":
        const subject = taskPaneState?.emailSubject;
        const subText = value? (!!subject && subject?.length > 60) ? subject.substring(0, 60) : subject || "" : ""
        setTaskPaneState((prev) => ({ ...prev, 
          [key]: value, 
          useChecklistItem: value? false: prev?.useChecklistItem,
          sameAsDocDesc: (!value && !prev?.useChecklistItem)? false : prev?.sameAsDocDesc,
          taskSubject: prev?.sameAsDocDesc? subText : prev?.taskSubject,
          docDescription: subText
        }));
        break;
      case "useChecklistItem":
        let checkItemText = "";
        if(checkList?.length && !!taskPaneState?.checklistItem) {
          const checkItemData = checkList.find(x => x.policyChecklistId == taskPaneState?.checklistItem)
          checkItemText = checkItemData?.description || "";
        }
        const descText = value? (!!checkItemText && checkItemText?.length > 60) ? checkItemText.substring(0, 60) : checkItemText || "" : "";
          setTaskPaneState((prev) => ({ ...prev, 
            [key]: value, 
            useFileName: value? false: prev?.useFileName,
            sameAsDocDesc: (!value && !prev?.useFileName)? false : prev?.sameAsDocDesc,
            taskSubject: prev?.sameAsDocDesc? descText : prev?.taskSubject,
            docDescription: descText
          }));
        break;
      default:
        setTaskPaneState((prev) => ({ ...prev, [key]: value }));
        break;
    }
  };
    const handleIndex = () => {
      dismissAllToasts();
      const maxSizeMB = 60;
      const maxSizeBytes = maxSizeMB * 1024 * 1024;
      const totalSize = sessionStorage.getItem("fileSize")
      if (+totalSize > maxSizeBytes) {
        notify("error", "File is larger than allowed size");
        return;
      }

      // check date validation
      const referenceDate = new Date("1900-01-01");
      if (taskPaneState?.receivedDate) {
        const dateToCheck = new Date(taskPaneState?.receivedDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Received Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskStartDate) {
        const dateToCheck = new Date(taskPaneState?.taskStartDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Start Date must be on or after 01/01/1900");
          return
        }
      }
      if (taskPaneState.taskDueDate) {
        const dateToCheck = new Date(taskPaneState?.taskDueDate);

        if (dateToCheck < referenceDate) {
          notify("error", "Due Date must be on or after 01/01/1900");
          return
        }
      }

        setLoading(true);
        callParentIndex();
  }
  const callParentIndex = async () => {
      try {
// Track a custom event
appInsights.trackEvent({ name: 'ButtonClicked', properties: { buttonName: 'SaveIndex', userID: taskPaneState?.userId } });
          const restId = sessionStorage.getItem('restId');
          const fromAddress = sessionStorage.getItem('fromAddress') || "unknown@example.com";
          const emailFromAddress = sessionStorage.getItem("emailFromAddress") || fromAddress;
     let SubmissionDetails = {
            SubmissionID: null,
            PolicyID: selectedItemDetailFromGrid?.policyID,
            DocType: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
            DocumentClassID: +taskPaneState.documentClass,
            WorkflowUserID: +taskPaneState?.userGroup,
            Destination: "",
            DestName: "",
            PipsProducer: {
              ProducerID: selectedItemDetailFromGrid?.ProducerID,
              IndexingUserID: taskPaneState?.userId
            },
            FileURL: null,
            Container: null,
            ExtractAttachments: false,
            OriginatingOfficeID: null,

            Sender: null,
            Recipient: null,
            CC: "",
            EmailHTML: null,
            FileContents: ""
          }
           const bodyData = {
                    subject: taskPaneState.taskSubject,
                    DocTypeId: taskPaneState?.documentType,
                    emailTime: "",
                    docTypeUsage: taskPaneState?.criteria === "Insured" || taskPaneState?.criteria === "Policy #" || taskPaneState?.criteria === "Submission #"? 1: 4,
                    description: taskPaneState?.docDescription?.length? taskPaneState?.docDescription.substring(0, 60):"",
                    dueDate: taskPaneState?.taskDueDate? new Date(taskPaneState?.taskDueDate): null,
                    pendDate: taskPaneState?.taskStartDate? new Date(taskPaneState?.taskStartDate): null,
                    modUserID: taskPaneState?.userId,
                    policyID: selectedItemDetailFromGrid?.policyID,
                    claimIncidentMasterID: 0,
                    providerID: 0,
                    producerID: 0,
                    destination: "",
                    destName: "",
                    workFlowUserID: +taskPaneState?.userGroup,
                    documentClassID: +taskPaneState?.documentClass,
                    compLocID: +taskPaneState?.comLocId,
                    indexNote: taskPaneState?.docNotes,
                    documentNote: taskPaneState?.docNotes,
                    note: taskPaneState?.taskNote,
                    task: taskPaneState?.taskChecked,
                    receivedDate: taskPaneState?.receivedDate? new Date(taskPaneState?.receivedDate) : null,
                    priorityID: +taskPaneState?.taskPriority,
                    taskTypeID: +taskPaneState?.taskType,
                    userGroupID: +taskPaneState?.userGroupId,
                    vendorID: 0,
                    campaignID: 0,
                    transSummaryID: 0,
                    docType: +taskPaneState?.documentType,
                    policyChecklistID: +taskPaneState?.checklistItem,
                    chkTask: !!taskPaneState?.taskChecked,
                    chkUseFileName: !!taskPaneState?.useFileName,
                    chkQuoteSentToProducer: !!taskPaneState?.chkQuoteSentToProducer,
                    intFileID: 0,
                    userID: taskPaneState?.userId,
                    queueID: +taskPaneState?.taskQueue,
                    fileID: 0,
                    workFlowUser: "",
                    workFlowDestination: "",
                    hostType: "Outlook",
                    fromAddress: fromAddress,
                    emailFromAddress,
                    actionType: actionType === "sendMailAndOpenTaskPane" ? "compose" : "read",
                    ewsItemId: restId,
                    submissionDetails: {
                      ...SubmissionDetails
                    }
       };
        if(!!sessionStorage.getItem("sharedOwner")) { 
          const jsonData = JSON.stringify({ isShared: true, ...bodyData });
          localStorage.setItem("indexData", jsonData);
          localStorage.setItem("sendIndex", "true");
          appInsights.trackDependencyData({
            target: process.env.BASE_URL,
            name: "Outlook_Saveindex_Payload",
            properties: { isShared: true, ...bodyData }
          });
        } else if (actionType === "sendMailAndOpenTaskPane") {
            setTimeout(() => {
                finalizeDownload(bodyData);
            }, 1000);
        } else {
            finalizeDownload(bodyData);
        }
   } catch (e) {
        console.log(e);
        setLoading(false);
   }
  }
    
    async function finalizeDownload(data) {
        
        try {
            const subject = sessionStorage.getItem("mailsubject") || "No Subject"

            //const files = new File([blob], `${subject}`, { type: blob.type });
            const bodyData = {
                ...data,
                FileName: `${subject}.eml`,
                FileType: "message/rfc822",
                submissionDetails: {
                    ...data.submissionDetails,
                    FileName: `${subject}.eml`,
                    FileType: "message/rfc822",
                }
            };
            const formData = new FormData();
            formData.append("file", null);
            formData.append("bodyData", JSON.stringify(bodyData));

            const fullUrl = `/saveindex/InsertImgInfo`;

            const settings = {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${sessionStorage.getItem('auth-token')}`
                },
                body: formData
            };
            const startTime = Date.now();
            // const uploadResponse = await fetch(fullUrl, settings);
            axios.post(fullUrl, formData, { timeout: 40000 }).then(() => {
          // Track a dependency (e.g., Graph API call)
          const duration = Date.now() - startTime;
            appInsights.trackDependencyData({
              target: process.env.BASE_URL,
              name: "Outlook_Saveindex_Payload",
              dependencyTypeName: "HTTPS",
              success: true,
              responseCode: 200,
              properties: bodyData,
              duration
            });
                if (actionType === "sendMailAndOpenTaskPane") Office.context.ui.messageParent("sendMail");
                else handleModel();
            }).catch((e) => {
                console.log(e);
                const errorText = e?.response?.data;
                const duration = Date.now() - startTime;
                 appInsights.trackDependencyData({
              target: process.env.BASE_URL,
              name: "Outlook_Saveindex_Payload",
              dependencyTypeName: "HTTPS",
              success: false,
              responseCode: e?.status || 500,
              properties: {
                bodyData: bodyData,
                error: e
              },
              duration
            });
                setLoading(false);
                if (e.code === 'ECONNABORTED') {
                    console.error("Something went wrong, please try again.");
                    notify("error", "Something went wrong, please try again.");
                } else {
                    if (e.status === 500 || e.status === 502) {
                        notify("error", errorText);
                    } else {
                        notify("error", "Failed to index");
                    }
                }
            })
        } catch (error) {
            console.log(error);
            // notify("error", "Failed to index");
            setLoading(false);
        }
    }


  const handleModel = () => {
      if (actionType === "sendMailAndOpenTaskPane") {
      Office.context.ui.messageParent(JSON.stringify({ close: true }));
    } else {
      localStorage.setItem("closeDialogFlag", "true");
    }
  }

    useEffect(() => {
        Office.onReady().then(() => {
        if (actionType === "sendMailAndOpenTaskPane") {
          Office.context.ui.messageParent("requestToken");
        } else window.localStorage.setItem("requestToken", "requestToken");
        Office.context.ui.addHandlerAsync(
          Office.EventType.DialogParentMessageReceived,
          (arg) => {
            if (arg.message === "Failed") {
              setLoading(false);
              notify("error", "Failed to index");

                 appInsights.trackDependencyData({
                   target: process.env.BASE_URL,
                   name: "Outlook_Saveindex_Payload",
                   dependencyTypeName: "HTTPS",
                   success: false,
                   responseCode: 500,
                   properties: {
                     bodyData: JSON.parse(localStorage.getItem("sendIndex")),
                     error: "Failed to index"
                   }
                 });
            } else if (arg.message === "ok") {
              // setLoading(false);
              notify("success", "Indexing successful!");
              handleModel();
            }

            const mes = JSON.parse(arg.message);

            console.log('reg', mes);
             if (!!mes?.token && mes?.itemID) {
              sessionStorage.setItem("mailsubject", mes?.mailsubject || "");
              sessionStorage.setItem("itemID", mes?.itemID || "");
              sessionStorage.setItem("restId", mes?.restId || "");
              sessionStorage.setItem("access-token", mes?.token);
              sessionStorage.setItem("fileSize", mes?.fileSize || 0);
              sessionStorage.setItem("sharedOwner", mes?.sharedOwner || "");
              sessionStorage.setItem("emailFromAddress", mes?.from || "");
              setAccessToken(mes?.token);
            }
            if (!!mes?.Failed && mes?.errorText) {
              notify("error", mes?.errorText);
              setLoading(false);
              appInsights.trackDependencyData({
                target: process.env.BASE_URL,
                name: "Outlook_Saveindex_Payload",
                dependencyTypeName: "HTTPS",
                success: false,
                responseCode: (mes?.errorText == "File is larger than allowed size")? 400 : 500,
                properties: {
                  bodyData: JSON.parse(localStorage.getItem("sendIndex")),
                  error: mes?.errorText
                }
              });
            }
          }
        );
      });
    }, []);

    const styles = useStyles();
    
    Office.onReady(() => {
    appInsights.trackPageView({ name: "Taskpane Loaded" });
  });

  const clearToaster = () => {
    dismissAllToasts();
    notify("progress");
  }

  useEffect(() => {
    dismissAllToasts();
  }, [selectedGridItem])
  
  return (
    <div className={styles.root}>
      {loading && <Loader />}
      <div className="page-bg">
        <div className="page-layout relative w-full mx-auto text-black z-10">
          {Toaster}
          <div className="main-container p-1 mt-1">
            <div className="card-layout p-2 shadow-md">
              <SearchCriteria
                              updateState={updateState}
                              clearToaster={clearToaster}
                              actionType={actionType }
              />
              <RecentList
                updateState={updateState}
              />
            </div>
            <IndexingForm updateState={updateState} handleIndex={handleIndex} handleModel={handleModel} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainContent;
